module.exports = __webpack_public_path__ + "static/media/05.6969cb0c.wav";